import { ROLES } from "models/constants/roles";

/** Adhoc system uptime report (super-only); matches API `system/uptime` */
export const REPORT_TYPE_SYSTEM_UPTIME = 13;

/** Fixed offset (hours) sent with system uptime report body */
export const SYSTEM_UPTIME_DEFAULT_TIMEZONE = 2;

export type ReportConfigItem = {
  id: number;
  name: string;
  classSelect: boolean;
  singleSelect: boolean;
  multiSelect: boolean;
  dateRange: boolean;
  models?: string[];
  /** Adhoc-only: no site/devices; body is from, to, timezone, optional email */
  systemReport?: boolean;
  /** If set, report is only listed for users who canShow(minRole) (e.g. super) */
  minRole?: string;
};

export const ReportConfiguration: ReportConfigItem[] = [
  {
    id: 8,
    name: "Alerts Report",
    classSelect: true,
    singleSelect: false,
    multiSelect: true,
    dateRange: true,
    models: ["tag.tmp", "tag.tmo", "lora.tmp", "lora.nanotag", "lora.humidity"],
  },
  {
    id: 3,
    name: "Electricity Report",
    classSelect: true,
    singleSelect: false,
    multiSelect: true,
    dateRange: true,
    models: ["tag.rhe", "tag.opt", "tag.eastron", "lte.opt"],
  },
  {
    id: 6,
    name: "Gas Report",
    classSelect: true,
    singleSelect: false,
    multiSelect: true,
    dateRange: true,
    models: ["stron.gas"],
  },
  {
    id: 4,
    name: "Hourly Report",
    classSelect: true,
    singleSelect: true,
    multiSelect: false,
    dateRange: true,
    models: [
      "tag.rhw",
      "tag.h2o",
      "tag.wmd",
      "tag.lvl",
      "tag.rhe",
      "tag.opt",
      "stron.gas",
      "tag.tmp",
      "tag.tmo",
      "lora.nanotag",
      "lora.tmp",
      "lora.humidity",
    ],
  },
  {
    id: 7,
    name: "Incident Report",
    classSelect: true,
    singleSelect: false,
    multiSelect: true,
    dateRange: true,
    models: ["tag.tmp", "tag.tmo", "lora.tmp", "lora.nanotag", "lora.humidity"],
  },
  {
    id: 1,
    name: "Raw Report",
    classSelect: true,
    singleSelect: true,
    multiSelect: false,
    dateRange: true,
    models: undefined,
  },
  {
    id: 9,
    name: "Uptime Extended Report",
    classSelect: true,
    singleSelect: false,
    multiSelect: true,
    dateRange: true,
    models: ["tag.tmp", "tag.tmo", "lora.tmp", "lora.nanotag", "lora.humidity"],
  },
  {
    id: 5,
    name: "Uptime Report",
    classSelect: true,
    singleSelect: false,
    multiSelect: true,
    dateRange: true,
    models: [
      "tag.rhw",
      "tag.h2o",
      "tag.wmd",
      "tag.rhe",
      "tag.opt",
      "lora.gateway",
      "stron.gas",
      "tag.tmp",
      "tag.tmo",
      "lora.tmp",
      "lora.nanotag",
      "lora.humidity",
    ],
  },
  {
    id: 2,
    name: "Water Report",
    classSelect: true,
    singleSelect: false,
    multiSelect: true,
    dateRange: true,
    models: ["tag.rhw", "tag.h2o", "tag.wmd"],
  },
  {
    id: 10,
    name: "TOU Report",
    classSelect: true,
    singleSelect: false,
    multiSelect: true,
    dateRange: true,
    models: ["tag.opt", "tag.eastron", "tag.rhe"],
  },
  {
    id: 11,
    name: "Water Reticulation Report",
    classSelect: true,
    singleSelect: false,
    multiSelect: true,
    dateRange: true,
    models: ["tag.rhw", "tag.h2o", "tag.wmd"],
  },
  {
    id: 12,
    name: "Electricity Reticulation Report",
    classSelect: true,
    singleSelect: false,
    multiSelect: true,
    dateRange: true,
    models: ["tag.opt", "tag.eastron", "tag.rhe"],
  },
  {
    id: REPORT_TYPE_SYSTEM_UPTIME,
    name: "System Uptime Report",
    classSelect: false,
    singleSelect: false,
    multiSelect: false,
    dateRange: true,
    models: undefined,
    systemReport: true,
    minRole: ROLES.ROLE_SUPER,
  },
];
